import { customFetch } from '../../../../shared/customFetch';
import { API_ROUTES } from '../../../shared/ApiRoutes';

export const getComptes = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.COMPTA.COMPTE(userId));
};

export const getGrandLivre = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.COMPTA.GL(userId));
};

export const getBalance = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.COMPTA.BALANCE(userId));
};
